/**
 * Получает Wazzup channelId на основе имени менеджера.
 * @param {string} managerName - Имя менеджера (например, "Иван Иванов").
 * @returns {Promise<string|null>} - ID канала Wazzup или null, если канал не найден.
 */
export const getWazzupChannelId = async (managerName) => {
    if (!managerName) {
      console.warn("Имя менеджера не указано");
      return null;
    }
  
    try {
      // Запрос к серверу для получения channelId
      const response = await fetch(
        `${process.env.REACT_APP_PATH_TO_BACKEND}/api/get-manager-channel?name=${encodeURIComponent(managerName)}`,
        { credentials: "include" }
      );
      const result = await response.json();
  
      if (result.success && result.channelId) {
        console.log(`Получен channelId для менеджера ${managerName}: ${result.channelId}`);
        return result.channelId;
      } else {
        console.warn(`Канал не найден для менеджера ${managerName}:`, result.message);
        return null;
      }
    } catch (err) {
      console.error(`Ошибка при получении channelId для менеджера ${managerName}:`, err);
      return null;
    }
  };